/**
 * What's On Slider Module
 *
 * @package EVT Restaurant Builder
 * @since 1.0.0
 */

/**
 * Initialize What's On slider pattern with Swiper.js
 */
export function initWhatsOnSlider() {
    const whatsOnContainers = document.querySelectorAll('.whats-on-slider');

    if (!whatsOnContainers.length) {
        return;
    }

    // Check if Swiper is available
    if (typeof Swiper === 'undefined') {
        console.warn('Swiper library not loaded. What\'s On slider will display as static content.');
        return;
    }

    whatsOnContainers.forEach(container => {
        const swiperContainer = container.querySelector('.whats-on__slider');
        const displayQty = parseInt(swiperContainer?.querySelector('.swiper-wrapper')?.dataset.display) || 1;
        const prevButton = container.querySelector('.whats-on__nav--prev');
        const nextButton = container.querySelector('.whats-on__nav--next');

        console.log("displayQty:", displayQty);
        if (!swiperContainer) {
            return;
        }

        // Initialize Swiper with responsive breakpoints
        const swiper = new Swiper(swiperContainer, {
            // Default settings (mobile)
            slidesPerView: 1,
            spaceBetween: 24,
            
            // Navigation
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },

            // Responsive breakpoints
            breakpoints: {
                // >= 768px (tablet and desktop)
                768: {
                    slidesPerView: 2,
                    spaceBetween: 32,
                },
                1024: {
                    slidesPerView: displayQty ? displayQty : 2,
                    spaceBetween: 32,
                },
            },

            // Loop behavior - only enable if we have more than 2 slides
            loop: false,
            
            // Accessibility
            a11y: {
                prevSlideMessage: 'Previous event',
                nextSlideMessage: 'Next event',
                firstSlideMessage: 'This is the first event',
                lastSlideMessage: 'This is the last event',
            },

            // Auto-height to accommodate varying content heights
            autoHeight: false,

            // Keyboard navigation
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },

            // Mouse wheel control (optional)
            mousewheel: {
                forceToAxis: true,
            },

            // Centered slides for better visual balance
            centeredSlides: false,

            // Grab cursor
            grabCursor: true,

            // Prevent clicks during transitions
            preventClicks: true,
            preventClicksPropagation: true,

            // Speed and effects
            speed: 400,
            
            // Enable/disable loop based on number of slides
            on: {
                init: function() {
                    const slideCount = this.slides.length;
                    
                    // Enable loop if we have more slides than visible
                    if (slideCount > 2) {
                        this.params.loop = true;
                        this.loopCreate();
                        this.update();
                    }

                    // Update navigation button states
                    updateNavigationStates(this, prevButton, nextButton);
                },
                slideChange: function() {
                    updateNavigationStates(this, prevButton, nextButton);
                },
                resize: function() {
                    // Recalculate on window resize
                    this.update();
                }
            }
        });

        // Store swiper instance for potential external access
        swiperContainer.swiper = swiper;
    });

    /**
     * Update navigation button states based on current slide
     * @param {Object} swiper - Swiper instance
     * @param {Element} prevButton - Previous button element
     * @param {Element} nextButton - Next button element
     */
    function updateNavigationStates(swiper, prevButton, nextButton) {
        if (!prevButton || !nextButton) return;

        // Remove disabled states
        prevButton.classList.remove('swiper-button-disabled');
        nextButton.classList.remove('swiper-button-disabled');

        // If not looping, handle disabled states
        if (!swiper.params.loop) {
            if (swiper.isBeginning) {
                prevButton.classList.add('swiper-button-disabled');
            }
            if (swiper.isEnd) {
                nextButton.classList.add('swiper-button-disabled');
            }
        }
    }

    // Handle window resize to update slider responsiveness
    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            whatsOnContainers.forEach(container => {
                const swiperContainer = container.querySelector('.whats-on__slider');
                if (swiperContainer && swiperContainer.swiper) {
                    swiperContainer.swiper.update();
                }
            });
        }, 250);
    });
}

/**
 * Destroy What's On sliders (useful for cleanup)
 */
export function destroyWhatsOnSliders() {
    const whatsOnContainers = document.querySelectorAll('.whats-on-slider');
    
    whatsOnContainers.forEach(container => {
        const swiperContainer = container.querySelector('.whats-on__slider');
        if (swiperContainer && swiperContainer.swiper) {
            swiperContainer.swiper.destroy(true, true);
        }
    });
}